// typewriter.component.ts
import { Component, Input, Output, EventEmitter, OnInit, OnDestroy } from '@angular/core';

@Component({
  selector: 'app-typewriter',
  template: `
    <div class="typewriter-container">
      <div *ngFor="let line of displayedLines" class="line">
        {{ line }}
      </div>
      <div class="cursor" *ngIf="isTyping">|</div>
    </div>
  `,
  styles: [`
    .typewriter-container {
      font-family: monospace;
      white-space: pre-wrap;
      line-height: 1.5;
      transition: opacity 0.5s ease-out;
    }
    .hidden {
      opacity: 0;
    }
    .line {
      margin: 0;
      padding: 0;
    }
    .cursor {
      display: inline-block;
      animation: blink 0.7s infinite;
      font-weight: bold;
    }
    @keyframes blink {
      0% { opacity: 1; }
      50% { opacity: 0; }
      100% { opacity: 1; }
    }
  `]
})
export class TypewriterComponent implements OnInit, OnDestroy {
  @Input() content: string = '';
  @Input() typingSpeed: number = 50;
  @Input() lineDelay: number = 500;
  @Output() completed = new EventEmitter<void>();

  displayedLines: string[] = [];
  private contentLines: string[] = [];
  private currentLineIndex: number = 0;
  private currentCharIndex: number = 0;
  isTyping: boolean = false;
  private timeoutRef: any = null;

  ngOnInit() {
    this.startTyping();
  }

  ngOnDestroy() {
    this.stopTyping();
  }

  private startTyping() {
    this.isTyping = true;
    this.contentLines = this.content.split('\n');
    this.typeNextCharacter();
  }

  public stopTyping() {
    if (this.timeoutRef) {
      clearTimeout(this.timeoutRef);
      this.timeoutRef = null;
    }
    this.isTyping = false;
    // Immediately show all content
    this.displayedLines = [...this.contentLines];
    this.completed.emit();
  }

  private typeNextCharacter() {
    if (this.currentLineIndex >= this.contentLines.length) {
      this.isTyping = false;
      this.completed.emit();
      return;
    }

    if (!this.displayedLines[this.currentLineIndex]) {
      this.displayedLines[this.currentLineIndex] = '';
    }

    const currentLine = this.contentLines[this.currentLineIndex];
    
    if (this.currentCharIndex < currentLine.length) {
      this.displayedLines[this.currentLineIndex] += currentLine[this.currentCharIndex];
      this.currentCharIndex++;
      this.timeoutRef = setTimeout(() => this.typeNextCharacter(), this.typingSpeed);
    } else {
      this.currentCharIndex = 0;
      this.currentLineIndex++;
      this.timeoutRef = setTimeout(() => this.typeNextCharacter(), this.lineDelay);
    }
  }
}